<div class="swiper-container swiper-container-cast">
    <div class="swiper-wrapper">
        <div class="swiper-slide actor-img" *ngFor="let actor of cast" [ngStyle]="{
            'background-size': 'cover',
            'background-image':'url(https://image.tmdb.org/t/p/w500' + actor.profile_path +')'}" (click)="onPersonClick( actor ) ">
            <div class="actor-data col ">
                <h5>CHARACTER:</h5>
                <h5>{{actor.character}}</h5>
                <div *ngIf="actor.gender==2 ">
                    <h6>ACTOR:</h6>
                </div>
                <h6 *ngIf="actor.gender==1 ">ACTRESS:</h6>
                <h6>{{actor.name}}</h6>
                <h5>Popularity: {{actor.popularity}}</h5>
            </div>
        </div>
    </div>
</div>